import classNames from 'classnames';

/**
 * Retorna a configuracao visual padrao de Dropdown usada no modulo de recebivel.
 *
 * @returns {import('primereact/dropdown').DropdownPassThroughOptions}
 */
export function getRecebivelDropdownPt() {
    return {
        root: ({ props }) => ({
            className: classNames(
                'cursor-pointer inline-flex relative select-none',
                'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-md',
                'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
                'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                'w-full ' + props.className,
                {
                    'opacity-60 select-none pointer-events-none cursor-default': props.disabled
                }
            )
        }),
        filtercontainer: 'relative',
        filterinput: {
            className: classNames(
                'pr-7 -mr-7 ',
                'w-full',
                'font-sans text-base text-gray-700 bg-white py-3 px-7 border border-gray-300 transition duration-200 rounded-lg appearance-none',
                'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80',
                'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]'
            )
        },
        filtericon: '-mt-2 ml-2 absolute top-1/2',
        itemLabel: 'font-semibold',
        item: ({ context }) => ({
            className: classNames(
                'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
                'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
                'dark:text-white/80 dark:hover:bg-gray-600/80 dark:hover:text-white',
                'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
                {
                    'text-gray-700': !context.focused && !context.selected,
                    'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
                    'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
                    'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled
                }
            )
        }),
    };
}
